/*
  Icon state
*/
export default {
  list: [],
  tripsByUnits: []
}
